export class GlobalConstants {
    /* OLD API USAGE - Deprecated by Wired Programming Multi-Tenant API
        public static apiURL = 'https://api.oldfaithfulplumbing.ca:443/api';
        public static dataServer = 'https://api.oldfaithfulplumbing.ca:443';
    */
   public static apiURL = 'https://api.wiredprogramming.com:443/api';
   public static dataServer = 'https://api.wiredprogramming.com:443';
   public static apiKey = 'newsalt91windyhippo53spicybread18';
};